import { styled } from "@vitality-ds/system";

import { HEADER_HEIGHT } from "../Header/constants";

export const MagentusFontFamilyOverride = {
  "span, div, p, h1, h2, h3, h4, li": {
    fontFamily: "'ABC Whyte', sans-serif !important",
  },
  "h1, h2": {
    letterSpacing: -0.25,
    fontWeight: 500,
  },
};
// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled("div", {
  marginBottom: "$lg",
  scrollMarginTop: HEADER_HEIGHT * 2,
  ...MagentusFontFamilyOverride,
  variants: {
    h1TopMargin: {
      true: {
        marginTop: "56px",
      },
    },
  },
});
